const config = {
  // CONFIGURACION
  NODE_ENV: process.env.NODE_ENV,
  IS_PRE: process.env.IS_PRE,
  IS_PRO: process.env.IS_PRO,
  homePath: process.env.homePath || '/',
  promoterCode: process.env.promoterCode,
  loginMessage: 'La Administración Pública nos ha comunicado que FACe parará sus servicios desde el 27 de Febrero. Por este motivo, no se enviarán ni descargarán facturas de FACe hasta que se restablezcan los servicios. Disculpe las molestias',
  showLoginMessage: false,
  invalidUserMail: process.env.invalidUserMail || 'soporte.sistemaefactura@unifiedpost.com',
  supportEmail: process.env.supportEmail || 'soporte.sistemaefactura@unifiedpost.com',

  // API URL
  urlSicapApi: process.env.SICAP_API_URL || '/sicap-api',
  tercerosCheckEndpoint: process.env.TERCEROS_CHECK_ENDPOINT || '/terceros/check',
  urlEurobitsUserManagement: process.env.API_USER_MANAGEMENT || 'http://sfe-pre-docker-01.eurobits.local:9097', // 'http://localhost:9097'
  urlEurobitsLogin: process.env.URL_EUROBITS_LOGIN || 'http://sfe-pre-docker-01.eurobits.local:9095', // 'http://localhost:9095'
  urlApiBack: process.env.API_BACK || 'http://sfe-pre-docker-01.eurobits.local:8000/eurobits', // 'http://localhost:8080/eurobits' 'http://sfe-pre-docker-02:8000/eurobits',
  urlEfacturaBugReport: process.env.API_BUG_URL_PRO || 'https://bug-api.sistemaefactura.com/api/v1', // faltaria URL PRE api bug
  // bugReportClientId: process.env.APIC_BUG_CLIENTID_PRO || '56506472-7c03-4c98-a73e-60bfc5b98688',

  // OAUTH
  oauth: {
    username: process.env.OAUTH_USERNAME || 'efactura',
    password: process.env.OAUTH_PASSWORD || 'DvfKC0s1Mp9'
  },

  // Google Analytics id
  googleAnalyticsId: process.env.IS_PRO ? process.env.GA_ID_PRO : process.env.GA_ID_PRE,

  // API - EXTERNAS
  urlApiUserIp: 'https://api.ipify.org/?format=json',

  // URL - APP CONFIGURATION
  urlEfactura: 'http://www.sistemaefactura.com',
  urlEfacturaMore: 'https://www.sistemaefactura.com/sistema-factura-pymes/que-es/',
  urlEurobitsTerms: '/static/doc/terms_and_conditions_sef.pdf',
  urlVerifactuStatement: '/static/doc/verifactu_statement_signed.pdf',

  /** URL PARA SOLICITAR FINANCIACIÓN DESDE UNA PESTAÑA EXTERNA */
  urlEurobitsFinanceables: process.env.URL_EUROBITS_FINANCEABLES || 'http://pre-cliente-demo.efactura.sistemaefactura.com/sfe/emitidas/financiacion', // http://localhost:8081/efactura2/emitidas/financiacion

  urlOldVersion: process.env.URL_OLD_VERSION || false,
  urlUserManual: process.env.URL_USER_MANUAL || 'http://efactura.usermanual.sistemaefactura.com/',
  urlLoginCas: process.env.IS_PRE ? 'http://pre-cliente.efactura.sistemaefactura.com/efactura-cas' : 'https://login-cas.sistemaefactura.com/efactura-cas/cas',
  urlLogoutCas: process.env.IS_PRE ? 'http://pre-cliente.efactura.sistemaefactura.com/efactura-cas/logout' : 'https://login-cas.sistemaefactura.com/efactura-cas/logout',
  urlVideoTutorial: process.env.promoterCode !== 9902 ? 'https://www.youtube.com/watch?v=FlJsXkhbIWI' : 'http://docs.larioja.org/audiovisuales/CMU_API/videoalta/N010080/1/482689.mp4',

  // SECURITY
  sslCookie: process.env.SSL_COOKIE,
  jwtCookieName: process.env.authCookieName,
  jwtDecodeSecret: '12345678901234567890123456789012',
  captchaSitekey: process.env.CAPTCHASITEKEY || '6Ldm2bkUAAAAAIXOMBekkRR5WzOeI0E7cuWsezNZ',
  useCaptcha: process.env.IS_PRO || false, /** true/false para activar/desactivar el uso de captcha. Por defecto se activa si: promoter 9900 + PRO. */
  cipherKey: 'KEBjkI@;g2Y9g7sTuRqL"wRi:B;ZJrz{',

  // STYLES
  staticPath: process.env.STATIC_PATH,
  chartColors: process.env.chartColors,

  // IMG
  logo: process.env.appLogo,
  recoveryLogo: process.env.appRecoveryLogo || process.env.appLogo,
  logoLink: process.env.appLogoLink || 'https://www.sistemaefactura.com',
  logoHeader: process.env.appLogoHeader || false,

  // APP CARACTERISTICAS
  features: {

    dateMask: 'DD/MM/YYYY',
    defaultCurrency: 'EUR',

    enableFaceB2b: process.env.enableFaceB2b || true, /**  Activa o desactiva que se vea el FaceB2b en los contactos o agenda */
    hasFactoring: process.env.hasFactoring || false, /** Sección de Factoring */
    requestFactoring: process.env.requestFactoring || false,
    requestFactoringMenuItem: process.env.requestFactoringMenuItem || false,

    hasTechnicalSupport: process.env.hasTechnicalSupport || false,
    hasExpedients: process.env.hasExpedients || false,
    hasPayment: process.env.hasPayment || false, /** Factura de abono o rectificadas en alta factura */
    hasContactContractReference: process.env.hasContactContractReference || false, /** Show Contract reference in ContactData component */
    hasContactCustomer: process.env.hasContactCustomer || false, /** Show customer al registrar y en el detalle de la factura */
    hasFundProvision: process.env.hasFundProvision || false, /** Show provisión  de fondos en el alta y detalle de factura */
    hasThirdpartyExpends: process.env.hasThirdpartyExpends || false, /** Muestra los gastos de facturas de terceros */
    hasCatalog: process.env.hasCatalog || false,
    hasKeyConfiguration: process.env.hasKeyConfiguration || false,
    hasMultiCompany: process.env.hasMultiCompany || false, /** Muestra en el menú superior esta opción. Solo habilitada para Rioja. */

    hasSelfBilling: process.env.hasSelfBilling || false,
    hasSettingsTerms: process.env.hasSettingsTerms || false,

    contactsSourceOptions: process.env.contactsSourceOptions,
    requestFactoringEmitInvoiceDelay: process.env.requestFactoringEmitInvoiceDelay || 0,
    mininmumFactoringAmount: process.env.mininmumFactoringAmount || 0, /** Valor mínimo para poder pedir financiación */
    duplicateDrafts: process.env.duplicateDrafts,
    disabeEditContacts: process.env.disabeEditContacts || false,
    usersSERIS: process.env.USERS_SERIS || [], /** cuando se crea una factura, si el cliente es un 'SERIS USER' de estos, se cambian un par de validaciones */
    unrequiredClientEmail: process.env.unrequiredClientEmail || false,
    editableAddedContact: process.env.editableAddedContact || false, /** Si es true, en el paso 1 de crear facturas, se permite la edición de la información de contacto al seleccionar de la agenda (habilitado en RSI y cajaLaboral).  */
    timeShowModalExpire: 10, /** Solo Rioja. Minutos. Tiempo para mostrar la ventana modal antes de que expire la sesión. */
    maxNotificationEmail: 5, /** Numero maximo de emails que se pueden configurar en las notificaciones */
    rectifyOnlyRejected: process.env.rectifyOnlyRejected || false, /** Permitir rectificar una factura únicamente cuando esté en estado rechazada */
    hideDepartment: process.env.hideDepartment || false,
    showVerifactu: process.env.showVerifactu || false
  }
}

export default config
